import React, { useMemo, useState, useRef, useEffect } from 'react';
import { useSelector } from "react-redux";
import useFetch from "../../hooks/useFetch";
import AILightComponent from '../../components/AILightComponent';
// import PDContestWinners from './PDContestWinners';
// import PDContestLeaders from './PDContestLeaders';
// import PDContest from './PDContest';
// import PDStreakHome from './PDStreakHome';

import {
    // ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
} from "recharts";

const DATA = {
    2026: [
        { month: "Jan", goated: 2, fire: 6, wday: 12, good: 8, lday: 3 },
        { month: "Feb", goated: 3, fire: 5, wday: 11, good: 7, lday: 2 },
        { month: "Mar", goated: 4, fire: 7, wday: 10, good: 8, lday: 2 },
        { month: "Apr", goated: 2, fire: 6, wday: 11, good: 8, lday: 3 },
        { month: "May", goated: 5, fire: 6, wday: 10, good: 7, lday: 3 },
    ],

    2025: [
        { month: "Jan", goated: 4, fire: 7, wday: 10, good: 8, lday: 2 },
        { month: "Feb", goated: 3, fire: 6, wday: 9, good: 8, lday: 2 },
        { month: "Mar", goated: 5, fire: 7, wday: 11, good: 6, lday: 2 },
        { month: "Apr", goated: 4, fire: 7, wday: 10, good: 7, lday: 2 },
        { month: "May", goated: 6, fire: 8, wday: 9, good: 6, lday: 2 },
        { month: "Jun", goated: 5, fire: 7, wday: 10, good: 6, lday: 2 },
        { month: "Jul", goated: 4, fire: 8, wday: 11, good: 6, lday: 2 },
        { month: "Aug", goated: 5, fire: 8, wday: 10, good: 6, lday: 2 },
        { month: "Sep", goated: 4, fire: 7, wday: 10, good: 7, lday: 2 },
        { month: "Oct", goated: 4, fire: 7, wday: 11, good: 7, lday: 2 },
        { month: "Nov", goated: 4, fire: 7, wday: 10, good: 7, lday: 2 },
        { month: "Dec", goated: 4, fire: 8, wday: 8, good: 8, lday: 3 },
    ],

    2024: [
        { month: "Jan", goated: 3, fire: 5, wday: 11, good: 10, lday: 2 },
        { month: "Feb", goated: 2, fire: 5, wday: 10, good: 10, lday: 2 },
        { month: "Mar", goated: 3, fire: 6, wday: 11, good: 9, lday: 2 },
        { month: "Apr", goated: 2, fire: 6, wday: 10, good: 10, lday: 2 },
        { month: "May", goated: 3, fire: 7, wday: 10, good: 9, lday: 2 },
        { month: "Jun", goated: 2, fire: 6, wday: 10, good: 10, lday: 2 },
        { month: "Jul", goated: 3, fire: 7, wday: 11, good: 8, lday: 2 },
        { month: "Aug", goated: 3, fire: 7, wday: 10, good: 9, lday: 2 },
        { month: "Sep", goated: 2, fire: 6, wday: 10, good: 10, lday: 2 },
        { month: "Oct", goated: 3, fire: 6, wday: 11, good: 9, lday: 2 },
        { month: "Nov", goated: 2, fire: 6, wday: 10, good: 10, lday: 2 },
        { month: "Dec", goated: 3, fire: 7, wday: 9, good: 10, lday: 2 },
    ],
};

export default function LifeReplays() {
    const authState = useSelector((state) => state.authReducer);
    const [fetchData] = useFetch();
    const userId = authState?.user?._id;
    const userCode = authState?.user?.think5whyscode;
    const userName = authState?.user?.name;

    const [openPanel, setOpenPanel] = useState(false);
    const [date, setDate] = useState( new Date().toISOString().split("T")[0]);
    const [mood, setMood] = useState("");
    const [error, setError] = useState("");
    const [tries, setTries] = useState(0);
    const [lock, setLock] = useState(false);
    const [history, setHistory] = useState([]);
    const [openYear, setOpenYear] = useState("2026");
    const [showLegend, setShowLegend] = useState(false);
    const [useSample, setUseSample] = useState(false);
    const [showAI, setShowAI] = useState(false);

    const [graphData, setGraphData] = useState(DATA);
    const [liveData, setLiveData] = useState({});

    const [subscriptions, setSubscriptions] = useState([]);
    const [selectedSubscription, setSelectedSubscription] = useState(null);
    const toDateOnly = (d) => (d ? d.split("T")[0] : null);

    const formatRange = (sub) => {
        if (!sub) return "";
        return `${sub.subscriptionId} (${new Date(sub.startDate).toLocaleDateString()} → ${new Date(sub.endDate).toLocaleDateString()})`;
    };

    const isExpired = selectedSubscription?.endDate
        ? new Date(selectedSubscription.endDate).getTime() < Date.now()
        : false;

    const effectiveIsActive = selectedSubscription?.isActive === true && !isExpired;
    const startDate = toDateOnly(selectedSubscription?.startDate);
    const endDate = toDateOnly(selectedSubscription?.endDate);


    const [loadingSubs, setLoadingSubs] = useState(false);

    const [successMsg, setSuccessMsg] = useState("");
    const [showMedals, setShowMedals] = useState(false);
    const [showStreaks, setShowStreaks] = useState(false);
    const [showRewards, setShowRewards] = useState(false);
    const [rewards, setRewards] = useState([]);
    const hasFetchedRewradsRef = useRef(false);

    const [showHistory, setShowHistory] = useState(false);
    
    // const isExpired = new Date(sub.endDate) < new Date();
    // const status = sub.isActive && !isExpired ? "Active" : "Inactive";
    // const years = Object.keys(DATA).sort((a, b) => b - a);
    // const years = Object.keys(liveData || {}).sort((a, b) => b - a);

    const activeData = useSample ? graphData : liveData;

    const years = Object.keys(activeData || {})
        .filter(Boolean)
        .sort((a, b) => b - a);

    const streakData = {
        weeklyStreak: 3,
        monthlyStreak: 1,
        currentStatus: "Weekly Streak Active 🔥",
    };

    useEffect(() => {
        if (useSample) {
            setGraphData(DATA);
        }
    }, [useSample]);

    const fetchMySubs = async () => {
        try {
            const config = {
                url: "/pd/subscription/my/light",
                method: "post",
                data: { userId, product: "LifeReplays" },
                headers: { Authorization: authState.token },
            };
            const response = await fetchData(config, { silent: true });

            if (response?.status) {
                const subs = response.data || [];
                setSubscriptions(subs);
                if (subs.length > 0) {
                    setSelectedSubscription(subs[0]);
                }
                // hasFetchedSubsRef.current = true;
            }
        } catch (error) {
            console.error("Fetch Subscription Error:", error);
        } finally {
            setLoadingSubs(false);
        }
    };

    useEffect(() => {
        if (userId) fetchMySubs();
    }, [userId]);

    useEffect(() => {
        const fetchLiveData = async () => {
            try {
                const res = await fetchData({
                    url: "/pd/lifereplay/history",
                    method: "post",
                    data: {
                        userId: authState?.user?._id,
                    },
                    headers: {
                        Authorization: authState.token,
                    },
                });

                const replayArray = res?.data?.data || res?.data || [];
                const formatted = transformReplayToYearStructure(replayArray);
                setLiveData(formatted);
                // FLATTEN for table
                const flat = replayArray.map((item) => ({
                    ...item,
                    date: item.replayDate.split("T")[0],
                }));
                setHistory(flat);
            } catch (err) {
                // console.log("LiveData fetch error:", err);
            }
        };

        fetchLiveData();
    }, []);

    const transformReplayToYearStructure = (replays) => {
        if (!Array.isArray(replays)) return {};

        const grouped = {};

        replays.forEach((item) => {
            const date = new Date(item.replayDate);

            const year = date.getFullYear();
            const month = date.toLocaleString("en-US", { month: "short" });

            if (!grouped[year]) {
                grouped[year] = {};
            }

            if (!grouped[year][month]) {
                grouped[year][month] = {
                    month,
                    goated: 0,
                    fire: 0,
                    wday: 0,
                    good: 0,
                    lday: 0,
                };
            }

            grouped[year][month][item.mood]++;
        });

        // convert object → array format (for recharts)
        const finalData = {};

        Object.keys(grouped).forEach((year) => {
            finalData[year] = Object.values(grouped[year]);
        });

        return finalData;
    };

    const handleReplaySave = async () => {
        try {
            const payload = {
                userId: authState?.user?._id,
                userCode: authState?.user?.userCode || authState?.user?.think5whyscode,
                userName: authState?.user?.name,
                mood,
                replayDate: date,
            };

            const response = await fetchData(
                {
                    url: "/pd/lifereplay/add",
                    method: "post",
                    data: payload,
                    headers: {
                        Authorization: authState.token,
                    },
                },
                { silent: true,  returnError: true  }
            );
            if (response?.type === "DUPLICATE_REPLAY") {
                setError("You already added Replay for this date");
                return;
            }
            if (!response.success) {
                throw {
                    message: response.message,
                    data: response,
                };
            }
            if (response?.type === "DUPLICATE_REPLAY") {
                setError(response.message);
                return;
            }
            setError(response?.message || "Something went wrong");
            if (response?.success) {
                setSuccessMsg("🎉 LifeReplay saved successfully!");
                setError("");
                setDate("");
                setMood("");
                setTries(0);
                return;
            }
            else {
                setError(response?.message || "Failed to save replay");
            }

        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.data?.message ||
                error?.message || null;

            setError("You already added Replay for this date");
            setTries((prev) => {
                const next = prev + 1;
                if (next >= 3) setLock(true);
                return next;
            });
        } 
    };

    const checkDate = async (d) => {
        try {
            const response = await fetchData(
                {
                    url: "/pd/lifereplay/check-date",
                    method: "post",
                    data: {
                        userId: authState?.user?._id,
                        replayDate: d,
                    },
                    headers: {
                        Authorization: authState.token,
                    },
                },
                { silent: true }
            );
            if (!response) {
                setError("No response from server");
                return;
            }
            if (response?.exists) {
                setError("Replay already exists for this date");
            } else {
                setError("");
            }

        } catch (error) {
            // console.log("Check Date Error:", error);
        }
    };

    const fetchMyStreaks = async () => {
        if (hasFetchedTodosRef.current) return;

        try {
            const config = {
                url: "/pd/contest/rewards",
                method: "post",
                data: { userId },
                headers: { Authorization: authState.token },
            };

            const response = await fetchData(config, { silent: true });

            if (response?.status) {
                setRewards(response.todos || []);
                hasFetchedTodosRef.current = true;
            }
        } catch (error) {
            console.error("Fetch Rewrads Error:", error);
            showMessage("Failed to load rewrads", "error");
        }
    };

    const formatError = (msg) => {
        if (!msg) return "";

        if (msg.toLowerCase().includes("already exists")) {
            return `⚠️ You have already added replay for ${date}`;
        }

        return msg;
    };

    const getMoodEmoji = (mood) => {
        switch (mood) {
            case "lday":
                return "😕";
            case "good":
                return "🙂";
            case "wday":
                return "😄";
            case "fire":
                return "🔥";
            case "goated":
                return "👑";
            default:
                return "🙂";
        }
    };
    const formatDate = (date) => date?.split("T")[0];

    const emojiMap = {
        lday: "😕",
        good: "🙂",
        wday: "😄",
        fire: "🔥",
        goated: "👑",
    };

    return (
        <div className="space-y-2 bg-gray-900 p-2 rounded-xl text-white min-h-screen">
            <div className="flex items-center justify-between p-2 rounded-2xl">
                <h2 className="text-sm lg:text-lg text-yellow-200 font-bold">
                    📈 Think5Whys LifeReplay
                </h2>
                <div className="text-[10px] text-gray-200">
                    {userName}{" - "}{userCode || "No Code"}
                </div>
            </div>
            <div className="flex flex-col lg:flex-row justify-between mb-1">
                <div className="flex flex-row gap-2">
                    <span className="text-cyan-300 text-xs p-1">
                        📋 Subscription
                    </span>

                    {loadingSubs ? (
                        <span className="text-gray-300 text-[10px]">
                            Loading...
                        </span>
                    ) : (
                        <select
                            className="bg-gray-800 text-white text-[10px] px-1 py-0.5 rounded-md border border-gray-600"
                            value={selectedSubscription?._id || ""}
                            onChange={(e) => {
                                const selected = subscriptions.find(
                                    (s) => s._id === e.target.value
                                );
                                setSelectedSubscription(selected || null);
                            }}
                            disabled={subscriptions.length === 0}
                        >
                            {subscriptions.length === 0 ? (
                                <option value="">No subscriptions found</option>
                            ) : (
                                subscriptions.map((sub) => {
                                    const isExpired = new Date(sub.endDate) < new Date();
                                    const status = sub.isActive && !isExpired ? "Active" : "Inactive";
                                    return (
                                        <option key={sub._id} value={sub._id}>
                                            {sub.product} |{" "}
                                            {new Date(sub.startDate).toLocaleDateString()} →{" "}
                                            {new Date(sub.endDate).toLocaleDateString()} |{" "}
                                            {status === "Active" ? "🟢 Active" : "🔴 Inactive"}
                                        </option>
                                    );
                                })
                            )}
                        </select>
                    )}
                </div>

                <div className="flex flex-row gap-1 items-center">
                    <button
                        disabled = {!effectiveIsActive}
                        onClick={() => setOpenPanel(true)}
                        className="text-white hover:text-cyan-600 w-8 text-xs lg:text-sm px-1 py-1 rounded-sm"
                    >
                        ➕
                    </button>
                    <button
                        onClick={() => setShowLegend(true)}
                        className="text-slate-400 hover:text-white w-8 text-xs lg:text-sm px-1 py-1 rounded-sm"
                        title="Info"
                    >
                        ℹ️
                    </button>
                    <button
                        onClick={() => setUseSample(true)}
                        className="text-yellow-300 hover:text-yellow-200 w-8 text-xs lg:text-sm px-1 py-1 rounded-sm"
                        title="Load Sample Dashboard"
                    >
                        📦
                    </button>
                    <button
                        onClick={() => setShowAI(true)}
                        className="text-purple-300 hover:text-purple-200 w-8 text-xs lg:text-sm px-1 py-1 rounded-sm"
                        title="AI Help"
                    >
                        🤖
                    </button>
                </div>
            </div>

            <div className="space-y-6 bg-gray-900 p-6 rounded-xl text-white border-t-2 border-purple-400 mt-2">

                {showLegend && (
                    <LegendModal setShowLegend={showLegend} setShowLegend={setShowLegend} />
                )}            
                {showAI && (
                    <div className="space-y-6 bg-gray-900 p-6 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
                        <div className="flex items-center justify-between p-2 rounded-2xl">
                            <h2 className="text-sm lg:text-lg text-yellow-200 font-bold">
                                🤖 AI LifeReplay AI Prompt Assistant to Analyse LifeReplays Life Mood
                            </h2>

                            <button
                                onClick={() => setShowAI(false)}
                                className="bg-blue-500 text-slate-400 hover:text-white w-10"
                            >
                                ✕
                            </button>
                        </div>

                        <AILightComponent
                            mode="daily_life_mood"
                            param1={"🔄 Smart Daily Life Mood Dashboard"}
                            param2={JSON.stringify({
                                graphData,
                                selectedYear: openYear,
                                summaryView: true,
                                feature: "LifeReplay stacked mood analytics dashboard"
                            }, null, 2)}
                        />
                    </div>
                )}

                {openPanel && (
                    <>
                    <div className="space-y-6 bg-gray-900 p-6 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
                        <div className="flex items-center justify-between p-2 rounded-2xl">
                            <h2 className="text-sm lg:text-lg text-yellow-200 font-bold">
                                🎬 Add LifeReplay
                            </h2>
                            <button
                                onClick={() => {
                                    setOpenPanel(false);
                                    setError("");
                                    setSuccessMsg("");
                                    setDate("");
                                    setMood("");
                                    setTries(0);
                                    setLock(false);
                                }}
                                className="w-10 bg-blue-700 text-slate-100 hover:text-white text-xs lg:text-sm"
                                title="Close"
                            >
                                ✕
                            </button>
                        </div>
                        <input
                            type="date"
                            className="w-40 p-2 bg-slate-800 rounded mb-3"
                            value={date}
                            onChange={(e) => setDate(e.target.value)}
                            min={startDate}
                            max={endDate}
                        />
                        <div className="grid grid-cols-5 gap-2 mb-3">
                            {[
                                "lday",
                                "good",
                                "wday",
                                "fire",
                                "goated",
                            ].map((m) => (
                                <button
                                    key={m}
                                    onClick={() => setMood(m)}
                                    className={`text-sm w-20 py-2 px-1 rounded ${
                                        mood === m
                                            ? "bg-cyan-500"
                                            : "bg-slate-800"
                                    }`}
                                >
                                    {m === "lday" && "😕"}
                                    {m === "good" && "🙂"}
                                    {m === "wday" && "😄"}
                                    {m === "fire" && "🔥"}
                                    {m === "goated" && "👑"}
                                </button>
                            ))}
                        </div>
                        {history.length > 0 && (
                            <div className="mb-3 text-xs text-slate-400">
                                Already logged:
                                <div className="flex flex-wrap gap-1 mt-1">
                                    {history.map((h) => (
                                        <span
                                            key={h._id}
                                            className="bg-slate-800 px-2 py-1 rounded"
                                        >
                                            {h.replayDate.split("T")[0]} {emojiMap[h.mood]}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                        {successMsg && (
                            <div className="text-green-400 text-sm mb-3 bg-green-500/10 p-2 rounded">
                                {successMsg}
                            </div>
                        )}
                        {error && (
                            <div className="text-red-400 text-sm mb-2">
                                {error}
                            </div>
                        )}
                        <button
                            disabled={lock || !mood || !date}
                            onClick={handleReplaySave}
                            className="bg-cyan-600 w-fit px-2 py-1 text-xs lg:text-sm rounded disabled:opacity-50"
                        >
                            💾 Save to My Replay
                        </button>

                        {tries >= 3 && (
                            <div className="text-red-400 text-xs mt-2">
                                Too many attempts. Please check history first.
                            </div>
                        )}
                    </div>          
                    </>
                )}

                <div className='rounded-xl p-4 border border-gray-700'>
                    <button
                        onClick={() => setShowHistory((p) => !p)}
                        className="w-fit px-2 py-1 bg-slate-700 text-white text-xs rounded"
                    >
                        {showHistory ? "Hide History" : "Show History"}
                    </button>
                
                    {showHistory && (
                        <>
                            {/* DESKTOP TABLE */}
                            <div className="mt-4 text-xs text-slate-100 hidden sm:block overflow-x-auto">
                                <table className="w-full border border-slate-700 min-w-[400px]">
                                    <thead className="bg-slate-800">
                                        <tr>
                                            <th className="p-2">SN</th>
                                            <th className="p-2">Date</th>
                                            <th className="p-2">Mood</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {history.length === 0 ? (
                                            <tr>
                                                <td colSpan={3} className="p-2 text-center text-slate-200">
                                                    No history found
                                                </td>
                                            </tr>
                                        ) : (
                                            history.map((h, idx) => (
                                                <tr key={h._id} className="border-t border-slate-700">
                                                    <td className="p-2">{idx + 1}</td>
                                                    <td className="p-2">{formatDate(h.replayDate)}</td>
                                                    <td className="p-2">
                                                        {getMoodEmoji(h.mood)} {h.mood}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>

                            {/* MOBILE CARDS */}
                            <div className="sm:hidden space-y-2 mt-4">
                                {history.length === 0 ? (
                                    <div className="text-center text-slate-200 text-xs">
                                        No history found
                                    </div>
                                ) : (
                                    history.map((h, idx) => (
                                        <div key={h._id} className="bg-slate-800 p-2 rounded">
                                            <div className="text-[10px] text-slate-100">
                                                #{idx + 1}{" "}{formatDate(h.replayDate)}{" "}{getMoodEmoji(h.mood)} {h.mood}
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </>
                    )}  
                </div>

                {/* YEARS */}
                {useSample && (
                    <div className="space-y-6 bg-gray-700 p-2 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
                        📦 You are viewing SAMPLE DASHBOARD DATA (for demo purpose)
                    </div>
                )}

                <div className="space-y-4">
                    {activeData === null ? (
                        <div className="rounded-3xl border border-cyan-500/20 bg-slate-900 p-8 text-center">
                        <div className="text-4xl animate-pulse">📊</div>

                        <div className="mt-3 text-cyan-300 font-semibold">
                            Loading your LifeReplay...
                        </div>

                        <div className="mt-2 text-slate-400 text-sm">
                            Analyzing your journey and preparing insights.
                        </div>
                        </div>
                    ) : years.length === 0 ? (
                        <div className="rounded-3xl border border-yellow-500/20 bg-slate-900 p-8 text-center">
                        <div className="text-lg lg:text-xl mb-1">🚀</div>

                        <div className="text-sm lg:text-lg font-bold text-yellow-300">
                            Your LifeReplay Journey Starts Here
                        </div>

                        <div className="mt-1 text-slate-300 max-w-xl mx-auto text-xs lg:text-sm">
                            No replay entries have been recorded yet. Start tracking your days to
                            unlock monthly trends, yearly insights, achievements, growth patterns,
                            and personal transformation analytics.
                        </div>

                        <div className="mt-6 grid md:grid-cols-3 gap-2 text-xs lg:text-sm">
                            <div className="rounded-xl bg-slate-800 p-1 text-xs lg:text-sm">
                            📅 Log Daily Experiences
                            </div>

                            <div className="rounded-xl bg-slate-800 p-1 text-xs lg:text-sm">
                            📈 Discover Growth Trends
                            </div>

                            <div className="rounded-xl bg-slate-800 p-1 text-xs lg:text-sm">
                            🏆 Build Your Replay Legacy
                            </div>
                        </div>

                        <div className="mt-2 text-xs lg:text-sm text-slate-500">
                            Your first recorded day will automatically appear here.
                        </div>
                        </div>
                    ) : (
                        years.map((year) => (
                            <YearCard
                                key={year}
                                year={year}
                                // data={useSample ? graphData[year] : (liveData?.[year] || [])}
                                data={activeData?.[year] || []}
                                open={openYear === year}
                                onToggle={() =>
                                    setOpenYear(
                                        openYear === year ? null : year
                                    )
                                }
                            />
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

function LegendModal({ showLegend, setShowLegend }) {
    return (
        <div className="space-y-2 bg-gray-900 p-2 rounded-xl text-white border-t-2 border-cyan-200 mt-2">
            <div className="flex items-center justify-between p-2 rounded-xl">
                <h2 className="text-sm lg:text-lg text-yellow-200 font-bold">
                    📘 LifeReplay Guide
                </h2>

                <button
                    onClick={() => setShowLegend(false)}
                    className="bg-blue-500 text-white hover:text-gray-200 w-10"
                >
                    ✕
                </button>
            </div>

            <div className="space-y-3 text-xs lg:text-sm text-slate-100">

                <div>😕 Bad → L Day</div>
                <div>🙂 Good → Good Vibes</div>
                <div>😄 Better → W Day</div>
                <div>🔥 Great → Fire Day</div>
                <div>👑 Best → Goated Day</div>

                <hr className="border-slate-700 my-2" />

                <div className="text-cyan-200 text-xs lg:text-sm font-semibold">
                    Digital Generations Meaning
                </div>

                <div className="text-slate-200 text-xs lg:text-sm space-y-1">
                    <div>W = Win / good day</div>
                    <div>Fire = amazing day</div>
                    <div>Goated = best ever</div>
                    <div>Peak = extremely good</div>
                    <div>We cooked = performed well</div>
                </div>
            </div>
        </div>
    );
}

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;

  const data = payload[0]?.payload;

  return (
    <div
      className="
        bg-slate-900/95
        border border-cyan-500/40
        rounded-2xl
        shadow-2xl
        p-4
        min-w-[220px]
      "
    >
      <div className="text-cyan-300 font-bold text-xs lg:text-sm mb-2">
        📅 {label}
      </div>

      <div className="space-y-1 text-xs lg:text-sm">
        <div className="flex justify-between">
          <span>🔥 Fire Days</span>
          <span className="font-bold">{data.fire}</span>
        </div>

        <div className="flex justify-between">
          <span>⚡ Goated Days</span>
          <span className="font-bold">{data.goated}</span>
        </div>

        <div className="flex justify-between">
          <span>😊 Good Days</span>
          <span className="font-bold">{data.good}</span>
        </div>

        <div className="flex justify-between">
          <span>😐 W Days</span>
          <span className="font-bold">{data.wday}</span>
        </div>

        <div className="flex justify-between">
          <span>😔 Low Days</span>
          <span className="font-bold">{data.lday}</span>
        </div>
      </div>

      <div className="border-t border-slate-700 mt-2 pt-2 text-xs lg:text-sm">
        <div className="flex justify-between text-yellow-300 font-semibold">
          <span className='text-xs lg:text-sm'>Total Logged</span>
          <span className='text-xs lg:text-sm'>
            {data.fire +
              data.goated +
              data.good +
              data.wday +
              data.lday}
          </span>
        </div>
      </div>
    </div>
  );
};

function YearCard({year, data = [], open, onToggle, setShowLegend,}) {
    const summary = useMemo(() => {
        const safeData = Array.isArray(data) ? data : [];
        let goated = 0;
        let fire = 0;
        let wday = 0;
        let good = 0;
        let lday = 0;

        safeData.forEach((m) => {
            goated += m.goated;
            fire += m.fire;
            wday += m.wday;
            good += m.good;
            lday += m.lday;
        });

        const bestMonth =
            safeData.length > 0
                ? [...safeData].sort(
                    (a, b) =>
                        (b.goated + b.fire + b.wday) -
                        (a.goated + a.fire + a.wday)
                )[0]
                : null;

        return {
            goated,
            fire,
            wday,
            good,
            lday,
            bestMonth,
        };
    }, [data]);

    return (
        <div className="rounded-3xl overflow-hidden border border-slate-800 bg-slate-900">
            <button
                onClick={onToggle}
                className="w-full p-2 flex justify-between items-center"
            >
                <div className="flex items-center gap-3">
                    <div className="w-8 h-8 text-xs lg:text-sm rounded-xl bg-cyan-500/10 flex items-center justify-center">
                        📅
                    </div>
                    <div className="text-left">
                        <div className="font-bold text-xs lg:text-sm">
                            {year}
                        </div>
                        <div className="text-xs text-slate-400">
                            {year === "2026"
                                ? "Current Year"
                                : "Historical Data"}
                        </div>
                    </div>
                </div>

                <div className="text-xs lg:text-sm">
                    {open ? "▼" : "▶"}
                </div>
            </button>
             
            {open && (
                <div className="p-2 border-t border-slate-800">
                    <div className="grid grid-cols-5 gap-2 mb-5">
                        <Stat emoji="👑" value={summary.goated} />
                        <Stat emoji="🔥" value={summary.fire} />
                        <Stat emoji="😄" value={summary.wday} />
                        <Stat emoji="🙂" value={summary.good} />
                        <Stat emoji="😕" value={summary.lday} />
                    </div>
                    <div className="mb-2 rounded-2xl bg-gradient-to-r from-cyan-500/10 to-purple-500/10 border border-cyan-500/20 p-4">
                        <div className="text-xs lg:text-sm text-slate-200">
                            BEST MONTH
                        </div>
                        <div className="text-xs lg:text-sm font-bold mt-1">
                            🏆 {summary.bestMonth?.month || "No activity yet"}
                        </div>
                        <div className="text-xs lg:text-sm text-slate-100">
                            Highest positive vibe score
                        </div>
                    </div>
                    {/* <div className="h-[420px] bg-slate-950 rounded-3xl p-3 border border-slate-800">
                        <ResponsiveContainer width="100%" height={320}>
                            <BarChart data={data}>
                                <CartesianGrid
                                    stroke="#1e293b"
                                />
                                <XAxis
                                    dataKey="month"
                                    stroke="#94a3b8"
                                />
                                <YAxis
                                    stroke="#94a3b8"
                                />
                                <Tooltip
                                    content={<CustomTooltip />}
                                    cursor={false}
                                />
                                <Bar
                                    stackId="a"
                                    dataKey="lday"
                                    fill="#ef4444"
                                />
                                <Bar
                                    stackId="a"
                                    dataKey="good"
                                    fill="#3b82f6"
                                />
                                <Bar
                                    stackId="a"
                                    dataKey="wday"
                                    fill="#22c55e"
                                />
                                <Bar
                                    stackId="a"
                                    dataKey="fire"
                                    fill="#f97316"
                                />
                                <Bar
                                    stackId="a"
                                    dataKey="goated"
                                    fill="#facc15"
                                />
                            </BarChart>
                        </ResponsiveContainer>
                    </div> */}
                    <div className="w-full h-[420px] bg-slate-950 rounded-3xl p-3 border border-slate-800">
                        {data?.length > 0 && (
                            // <ResponsiveContainer width="100%" height="100%">
                            <BarChart width={800} height={320} data={data}>
                                <CartesianGrid stroke="#1e293b" />
                                <XAxis dataKey="month" stroke="#94a3b8" />
                                <YAxis stroke="#94a3b8" />
                                <Tooltip content={<CustomTooltip />} cursor={false} />
                                <Bar stackId="a" dataKey="lday" fill="#ef4444" />
                                <Bar stackId="a" dataKey="good" fill="#3b82f6" />
                                <Bar stackId="a" dataKey="wday" fill="#22c55e" />
                                <Bar stackId="a" dataKey="fire" fill="#f97316" />
                                <Bar stackId="a" dataKey="goated" fill="#facc15" />
                            </BarChart>
                            // </ResponsiveContainer>
                        )}
                    </div>

                    <div className="mt-2 flex flex-wrap gap-3 text-xs lg:text-sm">
                        <div className='text-xs'>👑 Goated</div>
                        <div className='text-xs'>🔥 Fire</div>
                        <div className='text-xs'>😄 W Day</div>
                        <div className='text-xs'>🙂 Good</div>
                        <div className='text-xs'>😕 L Day</div>
                    </div>
                </div>
            )}
        </div>
    );
}

function Stat({ emoji, value }) {
    return (
        <div className="rounded-2xl bg-slate-950 border border-slate-800 p-3 text-center">
            <div className="text-sm lg:text-lg">{emoji}</div>
            <div className="font-bold mt-1">
                {value}
            </div>
        </div>
    );
}